import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "doer-page-fixed-head-spacer" }, null, -1)
const _hoisted_2 = { class: "doer-page-scroll-tabs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Выполнено")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "hide-max350" }, " услуг", -1)
const _hoisted_6 = {
  key: 0,
  class: "ion-text-center text-muted py-4"
}

import { ComponentPublicInstance, onMounted, ref, watch } from 'vue';
import { modalController } from '@ionic/vue';
import { RangeTabData, useDoerProvidedServicesStat, useDoersStatRangeTabs } from '@/composables/doer';
import AppHeaderForDoer from '@/components/layout/AppHeaderForDoer.vue';
import ProvideServicesTotalCard from '@/components/doer/ProvideServicesTotalCard.vue';
import DoerEmojiReportAndNav from '@/views/DoerEmojiReportAndNav.vue';
import VisitGroupCard from '@/components/doer/VisitGroupCard.vue';
import ChoiceBeetweenDateModal from './ChoiceBeetweenDateModal.vue';
import { computed } from '@vue/reactivity';
import { useUser } from '@/composables/useUser';
import { useStore } from '@/composables/useApp';
import { useMetrica } from '@/composables/useMetrica';
import { isClientError } from '@/repositories';
import moment from 'moment';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();
const { emitEvent } = useMetrica();

const startTime = ref<Date>(new Date());
const endTime = ref<Date>(new Date());
const selectedDateFormatted = computed(() => {
  const st = moment(startTime.value);
  const et = moment(endTime.value);
  if (st.isSame(et, 'date')) {
    return st.format('DD MMMM');
  }

  return st.format('DD MMMM') + ' - ' + et.format('DD MMMM');
});

const {
  rangeDateTabs,
  current: currentTab,
  rangeDateTabsKeyByName
} = useDoersStatRangeTabs({
  model: { startTime, endTime },
  choiceCustom: openChoiceBeetweenDateModal,
});

rangeDateTabsKeyByName.value['today'].setCurrent();

const {
  providedServices,
  total: totalDoerCost,
  loadStat,
  provideServicesGroupByCar,
} = useDoerProvidedServicesStat({
  startTime,
  endTime,
});

const loadingContentRef = ref<ComponentPublicInstance<any>|null>(null);
watch([startTime, endTime], () => {
    loadingContentRef.value?.load();
});

const tabsShow = ref(true);
function onScroll(ev: CustomEvent) {
  if (ev.detail.deltaY < -8 || ev.detail.scrollTop < 150) {
    tabsShow.value = true;
  } else if (ev.detail.deltaY > 10) {
    tabsShow.value = false;
  }
}

async function openEmojiAndNav() {
  const modal = await modalController.create({
    component: DoerEmojiReportAndNav as any,
    cssClass: 'doer-emoji-modal-view'
  });

  modal.present();

  emitEvent('home/mood-or-nav/open');
}

onMounted(() => {
  // Показываем мойщику, что ему нужно оценить работу.
  watch(store.doer.isForsedMood, forsed => {
    if (forsed) {
      openEmojiAndNav();
    }
  }, { immediate: true });
});

const { fullName: userFullname, user } = useUser();
const userId = computed(() => user.value?.userId || 0);

function setTab(tab: RangeTabData) {
  tab.setCurrent();
  emitEvent('home/tab/change', {
    label: tab.label,
    name: tab.name,
  });
}

function responseError(e: any) {
  if (isClientError(e) && e.response?.status == 401) {
    store.user.removeAuthToken();
    router.replace({ name: 'login' });
  }
}

async function openChoiceBeetweenDateModal() {
  const modal = await modalController.create({
    cssClass: 'modal-fullscreen',
    component: ChoiceBeetweenDateModal as any,
    componentProps: {
      value: [startTime.value, endTime.value],
      
      setBeetweenDate(between: { begin: Date; end: Date; }) {
        startTime.value = between.begin;
        endTime.value = between.end;
      }
    }
  });

  modal.present(); // async 

  return modal;
}

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_c_content_loading = _resolveComponent("c-content-loading")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(AppHeaderForDoer, {
        title: _unref(userFullname),
        "doer-id": _unref(userId),
        onOpenEmoji: openEmojiAndNav
      }, null, 8, ["title", "doer-id"]),
      _createVNode(_component_ion_content, {
        "scroll-events": true,
        onIonScroll: onScroll
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", {
            slot: "fixed",
            class: _normalizeClass({
        'doer-page-fixed-head': true,
        'doer-page-fixed-head--hide': !tabsShow.value,
      })
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rangeDateTabs), (tab) => {
                return (_openBlock(), _createBlock(_component_ion_button, {
                  key: tab.label,
                  onClick: ($event: any) => (setTab(tab)),
                  size: "small",
                  color: _unref(currentTab)?.name === tab.name ? 'primary' : 'dark',
                  shape: "round",
                  expand: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tab.label), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "color"]))
              }), 128))
            ]),
            _createVNode(ProvideServicesTotalCard, {
              class: "ion-margin-horizontal",
              "grand-total": _unref(totalDoerCost)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(selectedDateFormatted)) + " ", 1),
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _createTextVNode(": " + _toDisplayString(_unref(providedServices).length), 1)
              ]),
              _: 1
            }, 8, ["grand-total"])
          ], 2),
          _createVNode(_component_c_content_loading, {
            onResponseError: responseError,
            action: _unref(loadStat),
            ref_key: "loadingContentRef",
            ref: loadingContentRef
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(provideServicesGroupByCar), (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group._key,
                  class: "ion-padding-horizontal"
                }, [
                  _createVNode(VisitGroupCard, { "group-info": group }, null, 8, ["group-info"])
                ]))
              }), 128)),
              (!_unref(providedServices).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Нет данных "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["action"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})